import React from "react";

import { modal, MODAL_ID, MODAL_TYPE } from "containers/ReduxModal/emitter";
import DamageCoverage from "./damage-coverage";

const closeDamageCoverageModal = () => {
  modal.remove(MODAL_ID.DAMAGE_COVERAGE);
};

export const openDamageCoverageModal = ({
  connectionId,
  onDamageCoverageActivate,
}) => {
  modal.add(
    <DamageCoverage
      connectionId={connectionId}
      onClose={closeDamageCoverageModal}
      onDamageCoverageActivate={onDamageCoverageActivate}
    />,
    {
      id: MODAL_ID.DAMAGE_COVERAGE,
      type: MODAL_TYPE.ONBOARDING,
      onClose: closeDamageCoverageModal,
    },
  );
};
